var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.formVisible
    ? _c(
        "div",
        [
          _c("p", [
            _vm._v(
              "\n\t\t" + _vm._s(_vm.$t("update-required-data.text")) + "\n\t"
            )
          ]),
          _vm._v(" "),
          _vm.employeeGroupVisible
            ? _c("base-select", {
                attrs: {
                  options:
                    _vm.$store.state.session.user.companyCode.employeeGroup,
                  valueProp: "id",
                  label: "groupName",
                  placeholder: _vm.$t("signupOH.center-or-business-unit"),
                  state: _vm.fieldIsValid("employeeGroup"),
                  errorMsg: _vm.$t("signupOH.errors.center-or-business-unit")
                },
                model: {
                  value: _vm.$v.employeeGroup.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.employeeGroup, "$model", $$v)
                  },
                  expression: "$v.employeeGroup.$model"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.employeeNumberVisible
            ? _c(
                "b-form-group",
                [
                  _c("b-form-input", {
                    attrs: {
                      state: _vm.employeeNumberState,
                      placeholder: _vm.$t("signupOH.internal-code")
                    },
                    model: {
                      value: _vm.$v.employeeNumber.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.employeeNumber, "$model", $$v)
                      },
                      expression: "$v.employeeNumber.$model"
                    }
                  }),
                  _vm._v(" "),
                  _vm.employeeNumberIsValid === false
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(
                          _vm._s(_vm.$t("signupOH.errors.employee-number"))
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.employeeNumber.$dirty &&
                  _vm.$v.employeeNumber.$invalid &&
                  _vm.employeeNumberIsValid !== false
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(
                          "\n\t\t\t" +
                            _vm._s(
                              _vm.$t("signupOH.errors.required-employee-number")
                            ) +
                            "\n\t\t"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "alert alert-light mt-3 d-flex align-items-center"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "flex-grow-1",
                          staticStyle: { color: "black" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(
                                _vm.$t("update-required-data.contact-chat")
                              ) +
                              "\n\t\t\t"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "mdi mdi-chat-outline",
                        staticStyle: { color: "black" }
                      })
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dniVisible
            ? _c(
                "b-form-group",
                [
                  _c("b-form-input", {
                    attrs: {
                      state: _vm.dniState,
                      placeholder: _vm.$t("signupOH.registerNIF")
                    },
                    model: {
                      value: _vm.$v.dni.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.dni, "$model", $$v)
                      },
                      expression: "$v.dni.$model"
                    }
                  }),
                  _vm._v(" "),
                  _vm.dniIsValid === false
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(
                          "\n\t\t\t" +
                            _vm._s(
                              _vm.$t(
                                "update-required-data.messages.dni-already-exists"
                              )
                            ) +
                            "\n\t\t"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.dni.$dirty &&
                  _vm.$v.dni.$invalid &&
                  _vm.dniIsValid !== false
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(
                          "\n\t\t\t" +
                            _vm._s(_vm.$t("signupOH.errors.enterNIF")) +
                            "\n\t\t"
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.birthdateVisible
            ? _c(
                "div",
                [
                  _c("base-birthdate-input", {
                    attrs: { minorsAllowed: "" },
                    model: {
                      value: _vm.birthdate,
                      callback: function($$v) {
                        _vm.birthdate = $$v
                      },
                      expression: "birthdate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "base-button",
            {
              staticClass: "mt-3",
              attrs: { blue: "" },
              on: { click: _vm.submit }
            },
            [_vm._v(_vm._s(_vm.$t("update-required-data.save")))]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2538f36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2538f36","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/account/UpdateRequiredData.vue
// module id = 4417
// module chunks = 56